// material-ui
import { Grid } from '@mui/material';

// project imports
import ItemCountLightCard from '../../../ui-component/cards/ItemCountLightCard';
import { gridSpacing } from 'store/constant';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssetService from 'services/AssetService';
import HalogService from 'services/HalogService';
import UserService from 'services/UserService';
import GatewayService from 'services/GatewayService';
import useAuth from 'hooks/useAuth';
import { IconList, IconUser } from '@tabler/icons';
import HubIcon from '@mui/icons-material/Hub';
import ItemCountDarkCard from 'ui-component/cards/ItemCountDarkCard';

// ==============================|| DEFAULT DASHBOARD ||============================== //

const Dashboard = () => {
    const { user } = useAuth();
    const assetService = new AssetService();
    const halogService = new HalogService();
    const gatewayService = new GatewayService();
    const userService = new UserService();

    return (
        <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <ItemCountDarkCard
                            labelText="Assets"
                            icon={IconList}
                            redirectPath="/assets"
                            countFunction={() => assetService.getAssetsCount(user?.tenantId!)}
                        />
                    </Grid>
                    {(user?.isSystemAdmin || user?.role === 'Admin') && (
                        <Grid item lg={3} md={6} sm={6} xs={12}>
                            <ItemCountLightCard
                                labelText="DEVICES"
                                icon={DashboardIcon}
                                redirectPath="/halogs"
                                countFunction={() => halogService.getHalogsCount(user?.tenantId!)}
                            />
                        </Grid>
                    )}

                    {user?.isSystemAdmin && (
                        <Grid item lg={3} md={6} sm={6} xs={12}>
                            <ItemCountLightCard
                                labelText="Gateways"
                                icon={HubIcon}
                                redirectPath="/gateways"
                                countFunction={() => gatewayService.getGatewaysCount(user?.tenantId!)}
                            />
                        </Grid>
                    )}
                    {(user?.isSystemAdmin || user?.role === 'Admin') && (
                        <Grid item lg={3} md={6} sm={6} xs={12}>
                            <ItemCountLightCard
                                labelText="USERS"
                                icon={IconUser}
                                redirectPath="/users"
                                countFunction={() => userService.getUsersCount(user?.tenantId!)}
                            />
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Dashboard;
